import React from 'react';
import './style.scss';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { ClickAwayListener } from '@mui/material';
import Forms from '../../../molecules/forms';
import useDateRangePicker from './hooks';
import { toUSString } from '../../../atoms/func';

interface Props {
  id: string;
  label?: string | undefined;
  // eslint-disable-next-line no-unused-vars
  handleChangeStart?: (e: Date | null) => void;
  // eslint-disable-next-line no-unused-vars
  handleChangeEnd?: (e: Date | null) => void;
  startDate: { current: Date, min?: Date, max?: Date, disabled?: boolean }
  endDate: { current: Date, min?: Date, max?: Date, disabled?: boolean };
}

const DateRangePicker: React.FC<Props> = (props) => {
  const {
    id, label, startDate, endDate,
    handleChangeStart = () => null,
    handleChangeEnd = () => null,
  } = props;
  const {
    show, setShow,
  } = useDateRangePicker();

  return (
    <ClickAwayListener onClickAway={() => setShow(false)}>
      <div className={id}>
        <label htmlFor={id} className={label ? 'label' : 'd-none'}>{label}</label>
        <div className="position-relative">
          <button
            type="button"
            className={show ? 'input-date-range-picker input-date-range-picker-active' : 'input-date-range-picker'}
            onClick={() => setShow(!show)}
          >
            <div className="fz-14">{`${toUSString(startDate.current)} -  ${toUSString(endDate.current)}`}</div>
            <div style={{
              position: 'absolute', right: 15, top: 8, color: show ? 'black' : 'silver',
            }}
            >
              {!show ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
            </div>
          </button>
          <div className={show ? 'optionContainer p-3' : 'd-none'}>
            <div className="d-flex flex-wrap gap-2">
              <div style={{ width: '100%' }}>
                <Forms.ReactDatePicker
                  id="startDate"
                  selectedDate={startDate.current}
                  handleChange={(date) => {
                    if (date) handleChangeStart(date);
                  }}
                  label="From"
                  dateFormat="MM/dd/yyyy"
                  disabled={startDate.disabled}
                  minDate={startDate.min}
                  maxDate={startDate.max}
                />
              </div>
              <div style={{ width: '100%' }}>
                <Forms.ReactDatePicker
                  id="endDate"
                  selectedDate={endDate.current}
                  handleChange={(date) => {
                    if (date) handleChangeEnd(date);
                  }}
                  label="To"
                  dateFormat="MM/dd/yyyy"
                  disabled={endDate.disabled}
                  minDate={endDate.min}
                  maxDate={endDate.max}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </ClickAwayListener>
  );
};

export default DateRangePicker;
